import { render, staticRenderFns } from "./FlowCard.vue?vue&type=template&id=394c0c8e&"
import script from "./FlowCard.vue?vue&type=script&lang=js&"
export * from "./FlowCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports